import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Tooltip,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import {
  apiConstants,
  get,
  patchGeneric,
  postGeneric,
} from "../../../common/constants";
import * as React from "react";
import _ from "lodash";
import { useSnackbar } from "notistack";
import MUIModal from "../../../components/MuiModal";
import PageTitle from "../../../components/PageTitle";
import Switch from "@mui/material/Switch";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import EditIcon from "@mui/icons-material/Edit";
import { MerchantIsBlended } from "../IsBlended";
import UploadLogo from "../UploadLogo";
import { WeightFreeze } from "../WeightFreeze";
// import { MerchantPiiAccess } from "../merchantPiiAccess";
import KycDetails from "./kycDetails";
import { useForm } from "react-hook-form";
import {
  FormProvider,
  RHFTextField,
  RHFSelectField,
} from "../../../common/hook-form";
import { LoadingButton } from "@mui/lab";
import AddContactProfile from "./ContactProfile";
import AddIcon from "@mui/icons-material/Add";

function DetailsTab({ data, id, setReload }) {
  const [wallet, setWallet] = useState();
  const [inactiveWallets, setInactiveWallets] = useState([]);
  const [labelOpen, setLabelOpen] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [toggleConfirm, setToggleConfirm] = useState(false);
  const [toggleVal, setToggleVal] = useState();
  const [type, setType] = useState();
  // const [piiAccess, setPiiAccess] = useState(false);
  const [ndrManagedVal, setNdrManagedVal] = useState(false);
  const [isBlended, setIsBlended] = useState(false);
  const [defChannelName, setDefChannelName] = useState(null);
  const [wfStatus, setWFStatus] = useState(false);
  const [wfExist, setWFExist] = useState(false);
  const [d2cVal, setD2cVal] = useState(false);
  const [ptlVal, setPtlVal] = useState(false);
  const [dimensions, setDimensions] = useState({
    length: "",
    breadth: "",
    height: "",
    weight: "",
  });
  const [reload2, setReload2] = useState(0);
  const [logoType, setLogoType] = useState("default");
  const [defaultLogo, setDefaultLogo] = useState(null);
  const [webstoreLogos, setWebstoreLogos] = useState([]);
  const [categoryEditOpen, setCategoryEditOpen] = useState(false);
  const [businessCategoryEditOpen, setBusinessCategoryEditOpen] =
    useState(false);
  const [hubspotDealIdEditOpen, setHubspotDealIdEditOpen] = useState(false);
  const [salesPocNameEditOpen, setSalesPocNameEditOpen] = useState(false);
  const handleClose = () => {
    setLabelOpen(false);
  };

  const [paceEnabled, setPaceEnabled] = useState(false);

  const paceHandler = async (event) => {
    try {
      const value = event.target.checked;
      setPaceEnabled(value);
      await postGeneric(
        `${apiConstants.MERCHANT_DETAILS}/${id}/enableDisableAutomatedCourierAllocation`,
        {
          flag: value,
        }
      );
    } catch (error) {
      console.error(error);
    }
  };

  const walletType =
    wallet && wallet[0]?.walletType ? wallet[0]?.walletType : "";
  useEffect(() => {
    get(`${apiConstants.WALLET}?merchantId=${id}`)
      .then((res) => {
        const users = res.data.responseObj;
        let filtered_array = _.filter(users, ["isActive", true]);
        setWallet(filtered_array);
        // deactivated wallets still carrying money (residual left behind by a
        // Prepaid<->Postpaid switch) — surfaced so support sees it on the merchant page
        setInactiveWallets(
          _.filter(
            users,
            (w) =>
              !w.isActive &&
              (Math.round(w.walletBalance || 0) !== 0 ||
                Math.round(w.dueAmount || 0) !== 0)
          )
        );
      })
      .catch((err) => console.log(err));
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    setPtlVal(data?.isPTLMerchant);
    setD2cVal(data?.isD2CMerchant);
  }, [data]);

  const confirmToggle = (type, val) => {
    const newD2CVal = type === "isD2CMerchant" ? !val : d2cVal;
    const newPTLVal = type === "isPTLMerchant" ? !val : ptlVal;
    if (!d2cVal && !ptlVal) {
      setToggleConfirm(true);
      setToggleVal(val);
      setType(type);
    } else if (!newD2CVal && !newPTLVal) {
      enqueueSnackbar("At least one merchant type must remain enabled", {
        variant: "error",
      });
    } else {
      setToggleConfirm(true);
      setToggleVal(val);
      setType(type);
    }
  };
  const getMessage = () => {
    if (type === "isD2CMerchant") {
      return d2cVal
        ? "Do you want to disable the D2C merchant type?"
        : "Do you want to enable the D2C merchant type?";
    } else if (type === "isPTLMerchant") {
      return ptlVal
        ? "Do you want to disable the PTL merchant type?"
        : "Do you want to enable the PTL merchant type?";
    }
  };
  const handleCloseToggle = () => {
    setToggleConfirm(false);
    setType();
    setToggleVal();
  };
  const handleAgree = () => {
    const payload = {
      id: id,
      isD2CMerchant: type === "isD2CMerchant" ? !toggleVal : d2cVal,
      isPTLMerchant: type === "isPTLMerchant" ? !toggleVal : ptlVal,
    };
    patchGeneric(apiConstants.MERCHANT_UPDATE, payload)
      .then((res) => {
        setReload((reload) => reload + 1);
        handleCloseToggle();
        enqueueSnackbar("Success", { variant: "success" });
      })
      .catch((err) =>
        enqueueSnackbar(err.response?.data?.message, { variant: "error" })
      );
  };
  const [contactProfile, setContactProfile] = React.useState([]);

  const fetchMerchantDetails = () => {
    get(`${apiConstants.MERCHANT_DETAILS}/${id}`)
      .then((response) => {
        setIsBlended(response.data?.blended);
        setDefChannelName(response.data?.channelNameDefault);
        setContactProfile(response.data?.contactProfile);
        // setPiiAccess(response.data?.reportsPiiDataEnabled)
        setNdrManagedVal(response.data?.ndrManagedByProzo);
        setPaceEnabled(
          response.data?.automatedCourierAllocationEnabled || false
        );
        setDimensions({
          length: response.data?.merchantWeightFreezeConfig?.itemLength,
          breadth: response.data?.merchantWeightFreezeConfig?.itemBreadth,
          height: response.data?.merchantWeightFreezeConfig?.itemHeight,
          weight: response.data?.merchantWeightFreezeConfig?.itemWeight,
        });
        if (response.data?.merchantWeightFreezeConfig) {
          setWFStatus(
            response.data?.merchantWeightFreezeConfig?.singleWeightFreezeEnabled
          );
          setWFExist(true);
        }

        // Parse shipping config for logos
        const shippingConfigs = response.data?.shippingConfig?.configs || [];
        const defaultLogos = shippingConfigs.filter(
          (config) => !config.configDesc?.startsWith("ImageSHOPIFY_")
        );
        const webstoreLogoConfigs = shippingConfigs.filter((config) =>
          config.configDesc?.startsWith("ImageSHOPIFY_")
        );

        // Set default logo (pick first one if multiple exist)
        setDefaultLogo(defaultLogos.length > 0 ? defaultLogos[0] : null);

        // Set webstore logos with store names
        const webstoreLogosWithNames = webstoreLogoConfigs.map((config) => ({
          ...config,
          storeName:
            config.configDesc?.replace("ImageSHOPIFY_", "") || "Unknown Store",
        }));
        setWebstoreLogos(webstoreLogosWithNames);
      })
      .catch((err) => {
        console?.error(err);
      });
  };

  useEffect(() => {
    fetchMerchantDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reload2]);

  return (
    <div>
      {/* {isLoading && <Loader />} */}
      <PageTitle>
        Details {data && data?.name ? " / " + data.name : ""}
      </PageTitle>
      <Grid sx={{ paddingBottom: 2 }}>
        <Grid sx={{ paddingBottom: 2 }}>
          <Card>
            <CardHeader
              title={<Typography variant="h6">{"Merchant Details"}</Typography>}
            />
            <CardContent>
              <Grid
                container
                spacing={1}
                display={"flex"}
                alignItems={"center"}>
                <Grid item xs={6} md={3}>
                  <Typography variant="subtitle2" color={"black"}>
                    Merchant Id
                  </Typography>
                  <Typography
                    variant="caption"
                    color="textSecondary"
                    display="block"
                    sx={{ mt: 0.5 }}>
                    This is the system generated unique identifier of the
                    merchant. This id is used to identify the merchant in the
                    system.
                  </Typography>
                </Grid>
                <Grid item xs={6} md={3}>
                  <Typography variant="subtitle2">
                    {data && data.id ? data.id : ""}{" "}
                  </Typography>
                </Grid>
                <Grid item xs={6} md={3}>
                  <Typography variant="subtitle2" color={"black"}>
                    Merchant Brand Name
                  </Typography>
                  <Typography
                    variant="caption"
                    color="textSecondary"
                    display="block"
                    sx={{ mt: 0.5 }}>
                    This field is sent in all Whatsapp and SMS notifications to
                    the customer.
                  </Typography>
                </Grid>
                <Grid item xs={6} md={3}>
                  <Typography variant="subtitle2">
                    {data && data?.name ? data.name : ""}{" "}
                  </Typography>
                </Grid>

                <Grid item xs={6} md={3}>
                  <Typography variant="subtitle2" color={"black"}>
                    Merchant Category
                  </Typography>
                  <Typography
                    variant="caption"
                    color="textSecondary"
                    display="block"
                    sx={{ mt: 0.5 }}>
                    This field indicates whether the merchant is an SME or
                    Enterprise. This information is used for business analytics
                    and reporting.
                  </Typography>
                </Grid>
                <Grid item xs={6} md={3}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      flexWrap: "wrap",
                    }}>
                    {data && data?.merchantCategory && (
                      <Chip
                        size="small"
                        label={data.merchantCategory}
                        sx={{
                          fontSize: "0.75rem",
                          height: "24px",
                          "& .MuiChip-label": { px: 1 },
                        }}
                      />
                    )}
                    <Button
                      onClick={() => setCategoryEditOpen(true)}
                      variant="contained"
                      size="small"
                      color="secondary"
                      sx={{
                        borderRadius: 1,
                        fontSize: "0.7rem",
                        py: 0.25,
                        px: 1,
                        minWidth: "auto",
                        height: "24px",
                      }}
                      startIcon={
                        data?.merchantCategory ? (
                          <EditIcon sx={{ fontSize: "0.9rem" }} />
                        ) : (
                          <AddIcon sx={{ fontSize: "0.9rem" }} />
                        )
                      }>
                      {data?.merchantCategory ? "Edit" : "Add"}
                    </Button>
                  </div>
                </Grid>

                <Grid item xs={6} md={3}>
                  <Typography variant="subtitle2" color={"black"}>
                    Company Registered Name
                  </Typography>
                  <Typography
                    variant="caption"
                    color="textSecondary"
                    display="block"
                    sx={{ mt: 0.5 }}>
                    This is the companies legal entity name which also reflects
                    in the signed agreement with Prozo. For example Prozo's
                    registered name is Prozo Integrated Logistics Private
                    Limited.
                  </Typography>
                </Grid>
                <Grid item xs={6} md={3}>
                  <Typography variant="subtitle2">
                    {data && data?.companyName ? data.companyName : ""}{" "}
                  </Typography>
                </Grid>

                <Grid item xs={6} md={3}>
                  <Typography variant="subtitle2" color={"black"}>
                    Business Category
                  </Typography>
                  <Typography
                    variant="caption"
                    color="textSecondary"
                    display="block"
                    sx={{ mt: 0.5 }}>
                    This field indicates the business category or industry type
                    of the merchant. This information is used for business
                    analytics, reporting, and merchant segmentation.
                  </Typography>
                </Grid>
                <Grid item xs={6} md={3}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      flexWrap: "wrap",
                    }}>
                    {data && data?.businessCategory && (
                      <Chip
                        size="small"
                        label={data.businessCategory}
                        // variant="outlined"
                        sx={{
                          fontSize: "0.75rem",
                          height: "24px",
                          "& .MuiChip-label": { px: 1 },
                        }}
                      />
                    )}
                    <Button
                      onClick={() => setBusinessCategoryEditOpen(true)}
                      variant="contained"
                      size="small"
                      color="secondary"
                      sx={{
                        borderRadius: 1,
                        fontSize: "0.7rem",
                        py: 0.25,
                        px: 1,
                        minWidth: "auto",
                        height: "24px",
                      }}
                      startIcon={
                        data?.businessCategory ? (
                          <EditIcon sx={{ fontSize: "0.9rem" }} />
                        ) : (
                          <AddIcon sx={{ fontSize: "0.9rem" }} />
                        )
                      }>
                      {data?.businessCategory ? "Edit" : "Add"}
                    </Button>
                  </div>
                </Grid>
                <Grid item xs={6} md={3}>
                  <Typography variant="subtitle2" color={"black"}>
                    HubSpot Deal ID
                  </Typography>
                  <Typography
                    variant="caption"
                    color="textSecondary"
                    display="block"
                    sx={{ mt: 0.5 }}>
                    This is the HubSpot CRM deal identifier linked to this
                    merchant, used for sales tracking and reporting.
                  </Typography>
                </Grid>
                <Grid item xs={6} md={3}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      flexWrap: "wrap",
                    }}>
                    {data && data?.hubspotDealId && (
                      <Chip
                        size="small"
                        label={data.hubspotDealId}
                        sx={{
                          fontSize: "0.75rem",
                          height: "24px",
                          "& .MuiChip-label": { px: 1 },
                        }}
                      />
                    )}
                    <Button
                      onClick={() => setHubspotDealIdEditOpen(true)}
                      variant="contained"
                      size="small"
                      color="secondary"
                      sx={{
                        borderRadius: 1,
                        fontSize: "0.7rem",
                        py: 0.25,
                        px: 1,
                        minWidth: "auto",
                        height: "24px",
                      }}
                      startIcon={
                        data?.hubspotDealId ? (
                          <EditIcon sx={{ fontSize: "0.9rem" }} />
                        ) : (
                          <AddIcon sx={{ fontSize: "0.9rem" }} />
                        )
                      }>
                      {data?.hubspotDealId ? "Edit" : "Add"}
                    </Button>
                  </div>
                </Grid>
                <Grid item xs={6} md={3}>
                  <Typography variant="subtitle2" color={"black"}>
                    Sales POC
                  </Typography>
                  <Typography
                    variant="caption"
                    color="textSecondary"
                    display="block"
                    sx={{ mt: 0.5 }}>
                    This is the sales point of contact responsible for this
                    merchant account.
                  </Typography>
                </Grid>
                <Grid item xs={6} md={3}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      flexWrap: "wrap",
                    }}>
                    {data && data?.salesPocName && (
                      <Chip
                        size="small"
                        label={data.salesPocName}
                        sx={{
                          fontSize: "0.75rem",
                          height: "24px",
                          "& .MuiChip-label": { px: 1 },
                        }}
                      />
                    )}
                    <Button
                      onClick={() => setSalesPocNameEditOpen(true)}
                      variant="contained"
                      size="small"
                      color="secondary"
                      sx={{
                        borderRadius: 1,
                        fontSize: "0.7rem",
                        py: 0.25,
                        px: 1,
                        minWidth: "auto",
                        height: "24px",
                      }}
                      startIcon={
                        data?.salesPocName ? (
                          <EditIcon sx={{ fontSize: "0.9rem" }} />
                        ) : (
                          <AddIcon sx={{ fontSize: "0.9rem" }} />
                        )
                      }>
                      {data?.salesPocName ? "Edit" : "Add"}
                    </Button>
                  </div>
                </Grid>
                <Grid item xs={6} md={3}>
                  <Typography variant="subtitle2" color={"black"}>
                    Marketing
                  </Typography>
                  <Typography
                    variant="caption"
                    color="textSecondary"
                    display="block"
                    sx={{ mt: 0.5 }}>
                    Only marketing=Yes merchants/brands are visible anywhere
                    on the GrowthOS platform — everything else is excluded.
                  </Typography>
                </Grid>
                <Grid item xs={6} md={3}>
                  <MarketingToggle
                    marketingVal={data?.marketing}
                    merchantId={id}
                    setReload={setReload}
                  />
                </Grid>
                <Grid item xs={6} md={3}>
                  <Typography variant="subtitle2" color={"black"}>
                    Phone number
                  </Typography>
                  <Typography
                    variant="caption"
                    color="textSecondary"
                    display="block"
                    sx={{ mt: 0.5 }}>
                    This is the default registered phone number of the merchant
                    which was used during self-signup or was added when the
                    merchant was onboarded on Proship.
                  </Typography>
                </Grid>
                <Grid item xs={6} md={3}>
                  <Typography variant="subtitle2">
                    {data && data.contact_no ? data.contact_no : ""}{" "}
                  </Typography>
                </Grid>
                <Grid item xs={6} md={3}>
                  <Typography variant="subtitle2" color={"black"}>
                    Email Id
                  </Typography>
                  <Typography
                    variant="caption"
                    color="textSecondary"
                    display="block"
                    sx={{ mt: 0.5 }}>
                    This is default registered email id of the merchant which
                    was used during self-signup or was added when the merchant
                    was onboarded on Proship. This email id receives all email
                    notifications triggered Proship. Additionally this email id
                    always has admin access of the merchant account.
                  </Typography>
                </Grid>
                <Grid item xs={6} md={3}>
                  <Typography variant="subtitle2">
                    {data && data.email ? data.email : ""}{" "}
                  </Typography>
                </Grid>
                <Grid item xs={6} md={3}>
                  <Typography variant="subtitle2" color={"black"}>
                    Additional Merchant Id
                  </Typography>
                  <Typography
                    variant="caption"
                    color="textSecondary"
                    display="block"
                    sx={{ mt: 0.5 }}>
                    This is the additional unique identifier of the merchant.
                    This is currently not being used by Proship.
                  </Typography>
                </Grid>
                <Grid item xs={6} md={3}>
                  <Typography variant="subtitle2">
                    {data && data.merchantId ? data.merchantId : ""}{" "}
                  </Typography>
                </Grid>
                <Grid item xs={6} md={3}>
                  <Typography variant="subtitle2" color={"black"}>
                    Address
                  </Typography>
                  <Typography
                    variant="caption"
                    color="textSecondary"
                    display="block"
                    sx={{ mt: 0.5 }}>
                    This is the default registered address of the merchant which
                    was used during self-signup or was added when the merchant
                    was onboarded on Proship. This is not a verified address.
                  </Typography>
                </Grid>
                <Grid item xs={6} md={3}>
                  <Typography variant="subtitle2">
                    {data && data?.address ? data.address : ""},
                    {data && data.city ? data.city : ""},
                    {data && data.pincode ? data.pincode : ""},
                    {data && data.state ? data.state : ""},
                    {data && data.country ? data.country : ""}{" "}
                  </Typography>
                </Grid>
                <Grid item xs={6} md={3}>
                  <Typography variant="subtitle2" color={"black"}>
                    Wallet Type
                  </Typography>
                  <Typography
                    variant="caption"
                    color="textSecondary"
                    display="block"
                    sx={{ mt: 0.5 }}>
                    This is the type of wallet that the merchant has. This is
                    used to identify the wallet type of the merchant (Prepaid or
                    Postpaid).
                  </Typography>
                </Grid>
                <Grid item xs={6} md={3}>
                  <Typography variant="subtitle2">
                    {walletType ? (
                      <Chip variant="filled" label={walletType} />
                    ) : (
                      "-"
                    )}
                  </Typography>
                </Grid>
                <Grid item xs={6} md={3}>
                  <Typography variant="subtitle2" color={"black"}>
                    Credit Limit
                  </Typography>
                  <Typography
                    variant="caption"
                    color="textSecondary"
                    display="block"
                    sx={{ mt: 0.5 }}>
                    This is the credit limit of the merchant. This is the amount
                    of money that the merchant can spend on Proship in a
                    Postpaid wallet. Prepaid wallets do not have a credit limit.
                  </Typography>
                </Grid>
                <Grid item xs={6} md={3}>
                  <Typography variant="subtitle2">
                    {wallet && wallet[0]?.creditLimit
                      ? "₹ " + wallet[0]?.creditLimit.toFixed(2)
                      : "-"}{" "}
                  </Typography>
                </Grid>
                <Grid item xs={6} md={3}>
                  <Typography variant="subtitle2" color={"black"}>
                    Alert Threshold
                  </Typography>
                </Grid>
                <Grid item xs={6} md={3}>
                  <Typography variant="subtitle2">
                    {wallet && wallet[0]?.alertThreshold
                      ? "₹ " + wallet[0]?.alertThreshold.toFixed(2)
                      : "-"}{" "}
                  </Typography>
                </Grid>
                <Grid item xs={6} md={3}>
                  <Typography variant="subtitle2" color={"black"}>
                    Wallet Balance
                  </Typography>
                  <Typography
                    variant="caption"
                    color="textSecondary"
                    display="block"
                    sx={{ mt: 0.5 }}>
                    Money remaining on a Prepaid wallet (can go negative when
                    charges exceed the balance). Postpaid wallets do not use
                    this — they track money owed under Due Amount instead.
                  </Typography>
                </Grid>
                <Grid item xs={6} md={3}>
                  <Typography variant="subtitle2">
                    {wallet && wallet[0]?.walletBalance
                      ? "₹ " + wallet[0]?.walletBalance.toFixed(2)
                      : "-"}{" "}
                  </Typography>
                </Grid>
                <Grid item xs={6} md={3}>
                  <Typography variant="subtitle2" color={"black"}>
                    Due Amount
                  </Typography>
                </Grid>
                <Grid item xs={6} md={3}>
                  <Typography variant="subtitle2">
                    {wallet && wallet[0]?.dueAmount
                      ? "₹ " + wallet[0]?.dueAmount.toFixed(2)
                      : "-"}{" "}
                  </Typography>
                </Grid>
                {inactiveWallets.length > 0 && (
                  <>
                    <Grid item xs={6} md={3}>
                      <Typography variant="subtitle2" color={"black"}>
                        Inactive Wallet Residual
                      </Typography>
                      <Typography
                        variant="caption"
                        color="textSecondary"
                        display="block"
                        sx={{ mt: 0.5 }}>
                        Money left on this merchant's deactivated wallet after a
                        wallet switch. It is not part of the active wallet above
                        and needs settlement by finance.
                      </Typography>
                    </Grid>
                    <Grid item xs={6} md={3}>
                      {inactiveWallets.map((w) => (
                        <Box
                          key={w.id || w.walletType}
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                            gap: 0.5,
                            mb: 1,
                          }}>
                          <Chip
                            variant="outlined"
                            size="small"
                            label={`${w.walletType} (Inactive)`}
                          />
                          <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                            {Math.round(w.walletBalance || 0) !== 0
                              ? "Balance ₹ " +
                                (w.walletBalance || 0).toLocaleString("en-IN", {
                                  maximumFractionDigits: 2,
                                })
                              : "Due ₹ " +
                                (w.dueAmount || 0).toLocaleString("en-IN", {
                                  maximumFractionDigits: 2,
                                })}
                          </Typography>
                        </Box>
                      ))}
                    </Grid>
                  </>
                )}
                <Grid item xs={6} md={3}>
                  <Typography variant="subtitle2" color={"black"}>
                    Merchant Type
                  </Typography>
                  <Typography
                    variant="caption"
                    color="textSecondary"
                    display="block"
                    sx={{ mt: 0.5 }}>
                    The filters on control tower and admin panel will be based
                    on the merchant type. For example, if PTL is not chosen to
                    be true, this merchant will not be shown in the control
                    tower PTL health tab. Similarly, this merchant will not be
                    available in the merchant filter on PTL Shipments tab in
                    admin panel.
                  </Typography>
                </Grid>
                <Grid item xs={6} md={3} display={"flex"} flexWrap={"wrap"}>
                  <Typography variant="subtitle2" width={30} mt={1}>
                    PTL
                  </Typography>
                  <React.Fragment>
                    <Tooltip title={ptlVal ? "Disable" : "Enable"}>
                      <Switch
                        checked={ptlVal}
                        onChange={() => {
                          confirmToggle("isPTLMerchant", ptlVal);
                        }}
                      />
                    </Tooltip>
                    <Typography variant="subtitle2" width={30} mt={1} ml={4}>
                      D2C
                    </Typography>
                    <React.Fragment>
                      <Tooltip title={d2cVal ? "Disable" : "Enable"}>
                        <Switch
                          checked={d2cVal}
                          onChange={() => {
                            confirmToggle("isD2CMerchant", d2cVal);
                          }}
                        />
                      </Tooltip>
                    </React.Fragment>
                  </React.Fragment>
                </Grid>
                <Grid item xs={6} md={3}>
                  <Typography variant="subtitle2" color={"black"}>
                    NDR Managed By Prozo
                  </Typography>
                </Grid>
                <Grid item xs={6} md={3}>
                  <NDRManagedToggle
                    ndrManagedVal={ndrManagedVal}
                    merchantId={id}
                    setReload={setReload2}
                  />
                </Grid>
                <Grid item xs={6} md={3}>
                  <Typography variant="subtitle2" color={"black"}>
                    Blended Rate Card
                  </Typography>
                  <Typography
                    variant="caption"
                    color="textSecondary"
                    display="block"
                    sx={{ mt: 0.5 }}>
                    If Blended Rate Card is chosen to be true, the merchant will
                    not get an option to chose the courier partner when a
                    shipment is being created in merchant panel
                  </Typography>
                </Grid>
                <Grid item xs={6} md={3}>
                  <MerchantIsBlended
                    isBlended={isBlended}
                    merchantId={id}
                    setReload={setReload2}
                  />
                </Grid>
                {/* <Grid item xs={6} md={3}><Typography variant='subtitle2' color={"black"}>PII Access</Typography>
                                </Grid>
                                <Grid item xs={6} md={3} >
                                    <MerchantPiiAccess merchantId={id} piiAccess={piiAccess} setReload2={setReload2} />
                                </Grid> */}
                <Grid item xs={6} md={3}>
                  <Typography variant="subtitle2" color={"black"}>
                    Upload Default Shipping Label Logo
                  </Typography>
                  <Typography
                    variant="caption"
                    color="textSecondary"
                    display="block"
                    sx={{ mt: 0.5 }}>
                    This logo will appear on all shipping labels generated by
                    Proship. This logo will not be displayed wherever Proship is
                    not generating the label example ATS etc..
                  </Typography>
                </Grid>
                <Grid item xs={6} md={3}>
                  <Button
                    onClick={() => {
                      setLabelOpen(true);
                      setLogoType("default");
                    }}
                    variant="contained"
                    size="small"
                    color="secondary"
                    sx={{ borderRadius: 1 }}
                    startIcon={<FileUploadOutlinedIcon />}>
                    Upload
                  </Button>
                  {defaultLogo && (
                    <Typography
                      variant="caption"
                      display="block"
                      sx={{ mt: 1 }}>
                      Current Logo:
                      <a
                        href={defaultLogo.configValue}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          color: "#1976d2",
                          textDecoration: "underline",
                          marginLeft: "4px",
                        }}>
                        View Logo
                      </a>
                    </Typography>
                  )}
                </Grid>
                <Grid item xs={6} md={3}>
                  <Typography variant="subtitle2" color={"black"}>
                    Upload Webstore Wise Label Logo
                  </Typography>
                  <Typography
                    variant="caption"
                    color="textSecondary"
                    display="block"
                    sx={{ mt: 0.5 }}>
                    In case the merchant has multiple webstores integrated with
                    Proship, this logo will be displayed on the shipping label
                    for that particular webstore. However if not logo is updated
                    at a store level, the logo will be displayed as the default
                    logo.
                  </Typography>
                </Grid>
                <Grid item xs={6} md={3}>
                  <Button
                    onClick={() => {
                      setLabelOpen(true);
                      setLogoType("webstore");
                    }}
                    variant="contained"
                    size="small"
                    color="secondary"
                    sx={{ borderRadius: 1 }}
                    startIcon={<FileUploadOutlinedIcon />}>
                    Upload
                  </Button>
                  {webstoreLogos.length > 0 && (
                    <div style={{ marginTop: "8px" }}>
                      <Typography
                        variant="caption"
                        display="block"
                        sx={{ mb: 0.5 }}>
                        Existing Webstore Logos:
                      </Typography>
                      {webstoreLogos.map((logo, index) => (
                        <Typography
                          key={index}
                          variant="caption"
                          display="block"
                          sx={{ mb: 0.2 }}>
                          <strong>{logo.storeName}:</strong>
                          <a
                            href={logo.configValue}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              color: "#1976d2",
                              textDecoration: "underline",
                              marginLeft: "4px",
                            }}>
                            View Logo
                          </a>
                        </Typography>
                      ))}
                    </div>
                  )}
                </Grid>
                <Grid item xs={6}>
                  <Box display={"flex"} flexDirection={"row"} gap={1}>
                    <div>
                      <Typography
                        variant="subtitle2"
                        gutterBottom
                        color="text.primary">
                        Disable / Enable Automated Courier Allocation (PACE)
                      </Typography>
                      <Typography
                        variant="caption"
                        color={"textSecondary"}
                        display="block">
                        automated allocation will work only after this is
                        enabled
                      </Typography>
                    </div>
                    <Switch checked={paceEnabled} onChange={paceHandler} />
                  </Box>
                </Grid>
                <Grid item xs={6} md={3}>
                  <Typography variant="subtitle2" color={"black"}>
                    Test Merchant
                  </Typography>
                  <Typography
                    variant="caption"
                    color="textSecondary"
                    display="block"
                    sx={{ mt: 0.5 }}>
                    Excludes this merchant from the leadership dashboard's
                    shipment numbers entirely. Use for internal/demo accounts
                    only — never for a real client.
                  </Typography>
                </Grid>
                <Grid item xs={6} md={3}>
                  <IsTestMerchantToggle
                    isTestMerchantVal={data?.test_merchant}
                    merchantId={id}
                    setReload={setReload}
                  />
                </Grid>
              </Grid>
              <MUIModal
                open={labelOpen}
                handleClose={handleClose}
                title={
                  logoType === "default"
                    ? "Upload Default Shipping Label Logo"
                    : "Upload Webstore Wise Label Logo"
                }
                children={
                  <UploadLogo
                    merchantId={id}
                    setReload={setReload2}
                    setLabelOpen={setLabelOpen}
                    logoType={logoType}
                  />
                }
                maxWidth="md"
              />

              <MUIModal
                open={categoryEditOpen}
                handleClose={() => setCategoryEditOpen(false)}
                title={
                  data?.merchantCategory
                    ? "Edit Merchant Category"
                    : "Add Merchant Category"
                }
                children={
                  <MerchantCategoryEdit
                    merchantId={id}
                    currentCategory={data?.merchantCategory}
                    setReload={setReload}
                    onClose={() => setCategoryEditOpen(false)}
                  />
                }
                maxWidth="sm"
              />

              <MUIModal
                open={businessCategoryEditOpen}
                handleClose={() => setBusinessCategoryEditOpen(false)}
                title={
                  data?.businessCategory
                    ? "Edit Business Category"
                    : "Add Business Category"
                }
                children={
                  <BusinessCategoryEdit
                    merchantId={id}
                    currentBusinessCategory={data?.businessCategory}
                    setReload={setReload}
                    onClose={() => setBusinessCategoryEditOpen(false)}
                  />
                }
                maxWidth="sm"
              />

              <MUIModal
                open={hubspotDealIdEditOpen}
                handleClose={() => setHubspotDealIdEditOpen(false)}
                title={
                  data?.hubspotDealId
                    ? "Edit HubSpot Deal ID"
                    : "Add HubSpot Deal ID"
                }
                children={
                  <MerchantTextFieldEdit
                    merchantId={id}
                    fieldKey="hubspotDealId"
                    fieldLabel="HubSpot Deal ID"
                    currentValue={data?.hubspotDealId}
                    setReload={setReload}
                    onClose={() => setHubspotDealIdEditOpen(false)}
                  />
                }
                maxWidth="sm"
              />

              <MUIModal
                open={salesPocNameEditOpen}
                handleClose={() => setSalesPocNameEditOpen(false)}
                title={data?.salesPocName ? "Edit Sales POC" : "Add Sales POC"}
                children={
                  <SalesPocEdit
                    merchantId={id}
                    currentValue={data?.salesPocName}
                    setReload={setReload}
                    onClose={() => setSalesPocNameEditOpen(false)}
                  />
                }
                maxWidth="sm"
              />

              <Dialog
                open={toggleConfirm}
                onClose={handleCloseToggle}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullWidth>
                <DialogTitle id="alert-dialog-title">{""}</DialogTitle>
                <DialogContent>
                  <DialogContentText id="alert-dialog-description">
                    <Typography variant="subtitle1">{getMessage()}</Typography>
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button
                    onClick={handleAgree}
                    variant="contained"
                    size="small"
                    color="primary">
                    Yes
                  </Button>
                  <Button
                    onClick={handleCloseToggle}
                    variant="contained"
                    size="small"
                    color="error">
                    No
                  </Button>
                </DialogActions>
              </Dialog>
            </CardContent>
          </Card>
        </Grid>
        <Grid sx={{ paddingBottom: 2 }}>
          <Card>
            <CardHeader
              title={
                <Typography variant="h6">
                  Standard Weight Freeze
                  {wfExist && (
                    <Chip
                      color={!wfStatus ? "error" : "success"}
                      size="small"
                      label={
                        <Typography variant="subtitle2">
                          {" "}
                          {!wfStatus ? "DISABLED" : "ENABLED"}
                        </Typography>
                      }
                      sx={{ ml: 2 }}
                    />
                  )}
                </Typography>
              }
              subheader={
                !wfStatus && wfExist
                  ? "Weight Freeze is disabled. Press 'Enable' to activate it"
                  : wfStatus && wfExist
                  ? "Weight Freeze is enabled. Press 'Disable' to deactivate it."
                  : ""
              }
            />
            <CardContent>
              <WeightFreeze
                dimensions={dimensions}
                setReload={setReload2}
                data={data}
                wfStatus={wfStatus}
              />
            </CardContent>
          </Card>
        </Grid>
        <Grid sx={{ paddingBottom: 2 }}>
          <Card>
            <CardHeader
              title={<Typography variant="h6">{"Contacts Profile"}</Typography>}
              subheader={
                // <>
                //     <Typography variant="body2">
                //         {`Please add the the POC details of the merchant including L1 POC, Finance POC, etc.`}
                //     </Typography>
                // </>
                <>
                  <Typography variant="body2" gutterBottom>
                    The Contacts Profile is used for multiple purposes,
                    including communications, WhatsApp based pickup requests,
                    performance email, finance, and operational coordination.
                  </Typography>
                  <Typography variant="body2" gutterBottom>
                    <b>
                      Imp Note Regarding WhatsApp Based Pickup Request Flow:
                    </b>{" "}
                    Mobile numbers added below are automatically activated for
                    WhatsApp-based pickup request flow. These numbers will have
                    access to raise pickup requests across all pickup locations
                    linked to this merchant account.
                  </Typography>
                  <Typography variant="body2">
                    Ensure the added mobile number has an active WhatsApp
                    account. The pickup flow works only on the WhatsApp mobile
                    app (not on WhatsApp Web) as it uses a form-based
                    interaction model.
                  </Typography>
                </>
              }
            />
            <CardContent>
              <AddContactProfile
                merchantId={id}
                setReload={setReload2}
                contactProfile={contactProfile}
              />
            </CardContent>
          </Card>
        </Grid>
        <Grid sx={{ paddingBottom: 2 }}>
          <Card>
            <CardHeader
              title={
                <>
                  <Typography variant="h6">
                    {"Add or Update Channel Name"}
                  </Typography>
                </>
              }
              subheader={
                <>
                  <Typography
                    variant="caption"
                    color="textSecondary"
                    display="block"
                    sx={{ mt: 0.5 }}>
                    This is the channel from which the orders are placed by the
                    merchant example Shopify, Unicommerce, ProWMS, Vinculum etc.
                    Please update the channel name diligently to ensure all
                    analytics are correct.
                  </Typography>
                </>
              }
            />
            <CardContent>
              <Typography variant="body2">
                {`Current default channel name : `}
                <Chip
                  color={defChannelName ? "warning" : "default"}
                  size="small"
                  label={
                    <Typography variant="subtitle2">
                      {" "}
                      {defChannelName ? defChannelName : "None"}
                    </Typography>
                  }
                  sx={{ ml: 1 }}
                />
              </Typography>
              <DefaultChannelConfig
                merchantId={id}
                defChannelName={defChannelName}
                setReload={setReload2}
              />
            </CardContent>
          </Card>
        </Grid>
        <Grid sx={{ paddingBottom: 2 }}>
          <KycDetails data={data} id={id} setReload={setReload} />
        </Grid>
      </Grid>
    </div>
  );
}
export default DetailsTab;

// Marks a merchant as a test account (MongoMerchant.isTestMerchant — a real,
// existing field the sales dashboard already excludes by: SalesDashboardService
// .testMerchantIds() subtracts every flagged merchant from the leadership
// dashboard's aggregates before building the summary). This toggle is the only
// UI ops has to set that flag — it went through PATCH merchant/update the same
// way Merchant Category does (MerchantMongoRepositoryImpl.updateMerchant()
// already whitelists isTestMerchant; no backend change needed). Wire key is
// "test_merchant" (MongoMerchant.isTestMerchant is @JsonProperty("test_merchant")),
// not "isTestMerchant" — must match on both read and write or the PATCH silently no-ops.
const IsTestMerchantToggle = ({ isTestMerchantVal, merchantId, setReload }) => {
  const [toggleConfirm, setToggleConfirm] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const handleClose = () => {
    setToggleConfirm(false);
  };

  const confirmFunc = () => {
    setToggleConfirm(true);
  };

  const handleYes = () => {
    patchGeneric(`${apiConstants.MERCHANT_UPDATE}`, {
      id: merchantId,
      test_merchant: !isTestMerchantVal,
    })
      .then(() => {
        handleClose();
        setReload((reload) => reload + 1);
        enqueueSnackbar("Success", { variant: "success" });
      })
      .catch((err) => {
        handleClose();
        enqueueSnackbar(
          err.response?.data?.message
            ? err.response?.data?.message
            : "Some error occurred",
          { variant: "error" }
        );
      });
  };

  return (
    <>
      <Tooltip title={isTestMerchantVal ? "Unmark as test merchant" : "Mark as test merchant"}>
        <Switch
          checked={!!isTestMerchantVal}
          onChange={() => {
            confirmFunc();
          }}
        />
      </Tooltip>
      <Dialog
        open={toggleConfirm}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth>
        <DialogTitle id="alert-dialog-title">{""}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <Typography variant="subtitle1">
              {isTestMerchantVal
                ? "Unmark this merchant as a test account? It will start counting in leadership dashboard numbers again."
                : "Mark this merchant as a test account? It will be excluded from all leadership dashboard numbers."}
            </Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleYes}
            variant="contained"
            size="small"
            color="primary">
            Yes
          </Button>
          <Button
            onClick={handleClose}
            variant="contained"
            size="small"
            color="error">
            No
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

// Marks a merchant as onboarded via marketing (MongoMerchant.marketing) — the
// single flag GrowthOS filters every page by platform-wide (see
// GrowthOsMarketingScopeService, proship_mongo). Wire key is "marketing",
// matching the model field directly (no @JsonProperty override there).
const MarketingToggle = ({ marketingVal, merchantId, setReload }) => {
  const [toggleConfirm, setToggleConfirm] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const handleClose = () => {
    setToggleConfirm(false);
  };

  const confirmFunc = () => {
    setToggleConfirm(true);
  };

  const handleYes = () => {
    patchGeneric(`${apiConstants.MERCHANT_UPDATE}`, {
      id: merchantId,
      marketing: !marketingVal,
    })
      .then(() => {
        handleClose();
        setReload((reload) => reload + 1);
        enqueueSnackbar("Success", { variant: "success" });
      })
      .catch((err) => {
        handleClose();
        enqueueSnackbar(
          err.response?.data?.message
            ? err.response?.data?.message
            : "Some error occurred",
          { variant: "error" }
        );
      });
  };

  return (
    <>
      <Tooltip
        title={
          marketingVal
            ? "Unmark as marketing-onboarded"
            : "Mark as marketing-onboarded"
        }>
        <Switch
          checked={!!marketingVal}
          onChange={() => {
            confirmFunc();
          }}
        />
      </Tooltip>
      <Dialog
        open={toggleConfirm}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth>
        <DialogTitle id="alert-dialog-title">{""}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <Typography variant="subtitle1">
              {marketingVal
                ? "Unmark this merchant as marketing-onboarded? It (and its brand) will stop showing up anywhere on the GrowthOS platform."
                : "Mark this merchant as marketing-onboarded? It will start showing up across the GrowthOS platform (Executive Dashboard, Decision/Insights, SME Performance, etc.)."}
            </Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleYes}
            variant="contained"
            size="small"
            color="primary">
            Yes
          </Button>
          <Button
            onClick={handleClose}
            variant="contained"
            size="small"
            color="error">
            No
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

// Generic single-text-field editor for a MongoMerchant field, following the
// same PATCH merchant/update pattern as MerchantCategoryEdit below, without
// the category-list fetch (plain free text, never validated server-side —
// matching hubspotDealId/salesPocName's existing "never validated here" model
// comment).
const MerchantTextFieldEdit = ({
  merchantId,
  fieldKey,
  fieldLabel,
  currentValue,
  setReload,
  onClose,
}) => {
  const { enqueueSnackbar } = useSnackbar();

  const method = useForm({
    defaultValues: {
      [fieldKey]: currentValue || "",
    },
  });

  const { handleSubmit, reset } = method;

  const onSubmit = (data) => {
    const payload = {
      id: merchantId,
      [fieldKey]: data[fieldKey],
    };
    patchGeneric(`${apiConstants.MERCHANT_UPDATE}`, payload)
      .then(() => {
        setReload((reload) => reload + 1);
        enqueueSnackbar(`${fieldLabel} updated successfully`, {
          variant: "success",
        });
        onClose();
      })
      .catch((err) => {
        enqueueSnackbar(
          err.response?.data?.message
            ? err.response?.data?.message
            : "Some error occurred",
          { variant: "error" }
        );
      })
      .finally(() => reset());
  };

  return (
    <>
      <FormProvider methods={method} onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={2} sx={{ mt: 1 }}>
          <Grid item xs={12} md={6}>
            <RHFTextField label={fieldLabel} name={fieldKey} required />
          </Grid>
          <Grid item xs={12} md={6}>
            <LoadingButton
              variant="contained"
              size="small"
              type="submit"
              sx={{ mt: 2 }}>
              {currentValue ? "Update" : "Add"}
            </LoadingButton>
            <Button
              variant="contained"
              size="small"
              color="error"
              sx={{ ml: 1, mt: 2 }}
              onClick={() => {
                reset();
                onClose();
              }}>
              Cancel
            </Button>
          </Grid>
        </Grid>
      </FormProvider>
    </>
  );
};

const NDRManagedToggle = ({ ndrManagedVal, merchantId, setReload }) => {
  const [toggleConfirm, setToggleConfirm] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const handleClose = () => {
    setToggleConfirm(false);
  };

  const confirmFunc = () => {
    setToggleConfirm(true);
  };

  const handleYes = () => {
    postGeneric(`${apiConstants.MERCHANT_DETAILS}/${merchantId}/updatefield`, {
      field: "ndrManagedByProzo",
      value: !ndrManagedVal,
    })
      .then((res) => {
        handleClose();
        setReload((reload) => reload + 1);
        enqueueSnackbar("Success", { variant: "success" });
      })
      .catch((err) => {
        console.log(err);
        handleClose();
        enqueueSnackbar(
          err.response?.data?.message
            ? err.response?.data?.message
            : "Some error occurred",
          { variant: "error" }
        );
      });
  };

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={6} md={6}>
          <React.Fragment>
            <Tooltip title={ndrManagedVal ? "Disable" : "Enable"}>
              <Switch
                checked={ndrManagedVal}
                onChange={() => {
                  confirmFunc();
                }}
              />
            </Tooltip>
          </React.Fragment>
        </Grid>
      </Grid>
      <Dialog
        open={toggleConfirm}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth>
        <DialogTitle id="alert-dialog-title">{""}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <Typography variant="subtitle1">
              {"Are you sure you want to proceed ?"}
            </Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleYes}
            variant="contained"
            size="small"
            color="primary">
            Yes
          </Button>
          <Button
            onClick={handleClose}
            variant="contained"
            size="small"
            color="error">
            No
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

const DefaultChannelConfig = ({ merchantId, setReload }) => {
  const { enqueueSnackbar } = useSnackbar();

  const method = useForm({
    defaultValues: {
      channelName: "",
    },
  });

  const { handleSubmit, reset } = method;

  const onSubmit = (data) => {
    const payload = {
      channelName: data.channelName,
      merchantOid: merchantId,
    };
    postGeneric(`${apiConstants.MERCHANT_DETAILS}/defaultChannel`, payload)
      .then((res) => {
        setReload((reload) => reload + 1);
        enqueueSnackbar("Success", { variant: "success" });
      })
      .catch((err) => {
        console.log(err);
        enqueueSnackbar(
          err.response?.data?.message
            ? err.response?.data?.message
            : "Some error occurred",
          { variant: "error" }
        );
      })
      .finally(() => reset());
  };

  return (
    <>
      <FormProvider methods={method} onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={2} sx={{ mt: 1 }}>
          <Grid item xs={12} md={6}>
            <RHFTextField label="Channel Name" name="channelName" required />
          </Grid>
          <Grid item xs={12} md={6}>
            <LoadingButton
              variant="contained"
              size="small"
              type="submit"
              sx={{ mt: 2 }}>
              Submit
            </LoadingButton>
            <Button
              variant="contained"
              size="small"
              color="error"
              sx={{ ml: 1, mt: 2 }}
              onClick={() => {
                reset();
              }}>
              Reset
            </Button>
          </Grid>
        </Grid>
      </FormProvider>
    </>
  );
};

const MerchantCategoryEdit = ({
  merchantId,
  currentCategory,
  setReload,
  onClose,
}) => {
  const { enqueueSnackbar } = useSnackbar();

  const method = useForm({
    defaultValues: {
      merchantCategory: currentCategory || "",
    },
  });

  const { handleSubmit, reset } = method;

  const [categoryList, setCategoryList] = useState([]);

  useEffect(() => {
    get(apiConstants.GET_MERCHANT_CATEGORY).then((res) => {
      setCategoryList(res.data);
    });
  }, []);

  const onSubmit = (data) => {
    const payload = {
      id: merchantId,
      merchantCategory: data.merchantCategory,
    };
    patchGeneric(`${apiConstants.MERCHANT_UPDATE}`, payload)
      .then((res) => {
        setReload((reload) => reload + 1);
        enqueueSnackbar("Merchant category updated successfully", {
          variant: "success",
        });
        onClose();
      })
      .catch((err) => {
        console.log(err);
        enqueueSnackbar(
          err.response?.data?.message
            ? err.response?.data?.message
            : "Some error occurred",
          { variant: "error" }
        );
      })
      .finally(() => reset());
  };

  return (
    <>
      <FormProvider methods={method} onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={2} sx={{ mt: 1 }}>
          <Grid item xs={12} md={6}>
            <RHFSelectField
              label="Merchant Category"
              name="merchantCategory"
              options={categoryList.map((category) => ({
                value: category?.enum,
                label: category?.displayName,
              }))}
              required
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <LoadingButton
              variant="contained"
              size="small"
              type="submit"
              sx={{ mt: 2 }}>
              {currentCategory ? "Update" : "Add"}
            </LoadingButton>
            <Button
              variant="contained"
              size="small"
              color="error"
              sx={{ ml: 1, mt: 2 }}
              onClick={() => {
                reset();
                onClose();
              }}>
              Cancel
            </Button>
          </Grid>
        </Grid>
      </FormProvider>
    </>
  );
};

// Real Sales POC names from the GrowthOS platform (GrowthOsPerson), not free text -- a merchant
// can no longer be assigned a POC name that doesn't actually exist there. Same pattern as
// MerchantCategoryEdit above (fetch the list once, RHFSelectField), fieldKey/value both plain
// name strings since that's what MongoMerchant.salesPocName itself stores.
const SalesPocEdit = ({ merchantId, currentValue, setReload, onClose }) => {
  const { enqueueSnackbar } = useSnackbar();

  const method = useForm({
    defaultValues: {
      salesPocName: currentValue || "",
    },
  });

  const { handleSubmit, reset } = method;

  const [pocList, setPocList] = useState([]);

  useEffect(() => {
    get(apiConstants.GET_SALES_POCS).then((res) => {
      setPocList(res.data || []);
    });
  }, []);

  const onSubmit = (data) => {
    const payload = {
      id: merchantId,
      salesPocName: data.salesPocName,
    };
    patchGeneric(`${apiConstants.MERCHANT_UPDATE}`, payload)
      .then(() => {
        setReload((reload) => reload + 1);
        enqueueSnackbar("Sales POC updated successfully", {
          variant: "success",
        });
        onClose();
      })
      .catch((err) => {
        enqueueSnackbar(
          err.response?.data?.message
            ? err.response?.data?.message
            : "Some error occurred",
          { variant: "error" }
        );
      })
      .finally(() => reset());
  };

  return (
    <>
      <FormProvider methods={method} onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={2} sx={{ mt: 1 }}>
          <Grid item xs={12} md={6}>
            <RHFSelectField
              label="Sales POC"
              name="salesPocName"
              options={pocList.map((name) => ({ value: name, label: name }))}
              required
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <LoadingButton
              variant="contained"
              size="small"
              type="submit"
              sx={{ mt: 2 }}>
              {currentValue ? "Update" : "Add"}
            </LoadingButton>
            <Button
              variant="contained"
              size="small"
              color="error"
              sx={{ ml: 1, mt: 2 }}
              onClick={() => {
                reset();
                onClose();
              }}>
              Cancel
            </Button>
          </Grid>
        </Grid>
      </FormProvider>
    </>
  );
};

const BusinessCategoryEdit = ({
  merchantId,
  currentBusinessCategory,
  setReload,
  onClose,
}) => {
  const { enqueueSnackbar } = useSnackbar();

  const method = useForm({
    defaultValues: {
      businessCategory: currentBusinessCategory || "",
    },
  });

  const { handleSubmit, reset } = method;

  const onSubmit = (data) => {
    const payload = {
      id: merchantId,
      businessCategory: data.businessCategory,
    };
    patchGeneric(`${apiConstants.MERCHANT_UPDATE}`, payload)
      .then((res) => {
        setReload((reload) => reload + 1);
        enqueueSnackbar("Business category updated successfully", {
          variant: "success",
        });
        onClose();
      })
      .catch((err) => {
        console.log(err);
        enqueueSnackbar(
          err.response?.data?.message
            ? err.response?.data?.message
            : "Some error occurred",
          { variant: "error" }
        );
      })
      .finally(() => reset());
  };

  return (
    <>
      <FormProvider methods={method} onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={2} sx={{ mt: 1 }}>
          <Grid item xs={12} md={6}>
            <RHFTextField
              label="Business Category"
              name="businessCategory"
              placeholder="Enter business category"
              required
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <LoadingButton
              variant="contained"
              size="small"
              type="submit"
              sx={{ mt: 2 }}>
              {currentBusinessCategory ? "Update" : "Add"}
            </LoadingButton>
            <Button
              variant="contained"
              size="small"
              color="error"
              sx={{ ml: 1, mt: 2 }}
              onClick={() => {
                reset();
                onClose();
              }}>
              Cancel
            </Button>
          </Grid>
        </Grid>
      </FormProvider>
    </>
  );
};
